import { constants, typographyStyles } from "@newsela/angelou";

const { heading4Obj } = typographyStyles;

export const headerCss = {
  ...heading4Obj,
  margin: "8px 0",
  color: constants.colors.ui.neutral[600],
  textAlign: "left",
};
